var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370.6 370.6",
    style: {
      enableBackground: "new 0 0 370.6 370.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#595757;stroke-width:21.1513;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2C6CFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 10.6,
    className: "st0",
    width: 173,
    height: 328.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9,
    y: 116.2,
    className: "st1",
    width: 192.8,
    height: 117.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.8,
    y: 332.2,
    className: "st1",
    width: 245,
    height: 38.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/코일 및 기타용품.1783a85162ced1cdfcf370e12e642a1b.svg";
export { ForwardRef as ReactComponent };